<script setup lang="ts">
defineProps<{ error?: string }>()
</script>

<template>
    <p
        v-if="error"
        :aria-label="`Error: ` + error"
        tabindex="0"
        class="text-xs text-danger">
        {{ error }}
    </p>
</template>
